import Web3 from 'web3';

import * as env from '../env';

export const useWeb3 = (rpcUrl?: string) => {
  const web3 = new Web3(rpcUrl || env?.L1_RPC_URL);
  return web3;
};
